import { AlertCircle } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from 'shadcn/components/ui/Alert';

/**
 * A validation alert containing a list of errors.
 *
 * @param {Object} props
 * @param {Array} props.errors - An array of error objects with message property
 * @returns {JSX.Element} A validation alert component
 */
function ValidationAlert({ errors }) {
    return (
        errors.length > 0 && (
            <Alert variant="destructive">
                <AlertCircle />
                <AlertTitle className="text-left">Please fix the following errors</AlertTitle>
                <AlertDescription>
                    <ul className="flex flex-col items-start list-disc list-inside">
                        {errors.map((error, index) => (
                            <li key={index}>{error.message}</li>
                        ))}
                    </ul>
                </AlertDescription>
            </Alert>
        )
    );
}

export default ValidationAlert;
